import React from "react";
import { Container, ImageWrapper, Text } from "./styles";
import CheckIcon from "../../assets/icons/check.svg";
interface ApplicationScenariosProps {
  text: string;
}
const ApplicationScenarios: React.FC<ApplicationScenariosProps> = ({
  text,
}) => {
  return (
    <Container>
      <ImageWrapper>
        <img src={CheckIcon} alt={'alt'} />
      </ImageWrapper>
      <Text>{text}</Text>
    </Container>
  );
};

export default ApplicationScenarios;
